var qualityApp = angular.module('quality', ['commons.app']);